var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import ReactPaginate from 'react-paginate';
import { propArrayShape, propBool, propFunc, propId, propNumber, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import { CurrentProcessLoader } from '../../../../../Ui/Loading';
import ProfessionalMyPageTopMySeminarItem from '../MySeminarItem';
const ProfessionalMyPageTopMySeminarContent = (props) => {
    const { changePage, className, isCloning, isDeleting, isLoading, isSelf, items, loadData, onClickClone, onClickDelete, pageCount, selectedSeminarId, title, unmountRef, } = props;
    /**
     * ページングのイベント
     * @type {(function({selected: *}): Promise<void>)|*}
     */
    const onPageChange = useCallback(({ selected }) => __awaiter(void 0, void 0, void 0, function* () {
        const currentPage = selected + 1;
        yield loadData(currentPage);
        if (!unmountRef.current) {
            changePage(currentPage);
        }
    }), [loadData, changePage, unmountRef]);
    return (_jsxs("div", Object.assign({ className: clsx('professional_mypage_top_seminar_content', className) }, { children: [_jsx("h3", Object.assign({ className: clsx('project-title', isSelf ? 'orange' : 'blue') }, { children: _jsx("span", { children: title }) })), isLoading && _jsx(CurrentProcessLoader, {}), !isLoading && !items.length && (_jsx("p", Object.assign({ className: 'align-center' }, { children: "\u30BB\u30DF\u30CA\u30FC\u306F\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093" }))), items.map((item) => (_jsx(ProfessionalMyPageTopMySeminarItem, { isCloning: isCloning, isDeleting: isDeleting, item: item, onClickClone: onClickClone, onClickDelete: onClickDelete, selectedSeminarId: selectedSeminarId }, item.id))), items.length > 0 && (_jsx("div", Object.assign({ className: 'pagination-menu' }, { children: _jsx(ReactPaginate, { marginPagesDisplayed: 3, nextLabel: null, onPageChange: onPageChange, pageCount: pageCount, previousLabel: null }) })))] })));
};
ProfessionalMyPageTopMySeminarContent.propTypes = {
    changePage: propFunc().isRequired,
    className: propStr(),
    isCloning: propBool().isRequired,
    isDeleting: propBool(),
    isLoading: propBool().isRequired,
    isSelf: propBool(),
    items: propArrayShape().isRequired,
    loadData: propFunc().isRequired,
    onClickClone: propFunc().isRequired,
    onClickDelete: propFunc(),
    pageCount: propNumber().isRequired,
    selectedSeminarId: propId(),
    title: propStr().isRequired,
    unmountRef: propShape().isRequired,
};
ProfessionalMyPageTopMySeminarContent.defaultProps = {
    className: '',
    isDeleting: false,
    isSelf: false,
    onClickDelete: undefined,
    selectedSeminarId: undefined,
};
export default ProfessionalMyPageTopMySeminarContent;
